import React from "react";
import { Toast, Button } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";

import api from "./api";
import { wxfx } from "../../utils/wxfx.js";

import "./index.less";
// const { BMap } = window;
import AMapLoader from "@amap/amap-jsapi-loader";
let timer;
class InviteNewUsersShare extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            modalType: false,
            selectType: false,
            vCode: false,
            second: 60,
            phoneNumber: "",
            imageCode: "",
            messageCode: "",
            imgUrl: "",
            agreementUrl: "",
            serviceAgreenmentType: false,
            recordCode: "",
            province: "",
            city: "",
        };
    }

    // #/inviteNewUsersShare?lastNumber=xxxx&inviteCode=xxx
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    this.fx();
                }
            );
        }
    }

    fx() {
        wxfx({
            title: "注册远程慧联app即可获得5元充电券",
            imgUrl: "https://static.hellogil.com/oss-prod-unsafe-group/statics/6a8009d8063148ccb0ec9b39b02f41b3.png",
            desc: `充电券免费送，邀请越多奖励越多，还有机会瓜分千元充电大礼包。`,
            url: `${window.location.href}`,
        });
    }

    // 获取图片验证码
    getImgCode() {
        const { urlOps, phoneNumber } = this.state;
        this.setState(
            {
                modalImgCodeType: true,
            },
            () => {
                post({
                    url: api.imageCode,
                    data: {
                        phoneNumber: phoneNumber,
                        businessType: "REGISTER",
                    },
                }).then(
                    (res) => {
                        if (res.result === "success") {
                            this.setState({
                                imgUrl: "data:image/jpg;base64," + res.data,
                            });
                        } else {
                            Toast.info(res.msg, 1);
                        }
                    },
                    (res) => {
                        Toast.info("图片验证码获取失败", 1);
                    }
                );
            }
        );
    }

    // 获取验证码
    getMessageCode() {
        clearInterval(timer);
        const { urlOps, phoneNumber, imageCode } = this.state;
        let _this = this;
        post({
            url: api.messageCode,
            data: {
                phoneNumber: phoneNumber,
                audio: 0,
                imageCode: imageCode,
                businessType: "REGISTER",
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    _this.setState(
                        {
                            second: 59,
                            recordCode: res.data,
                            modalImgCodeType: false,
                            vCode: true,
                        },
                        () => {
                            let { second } = _this.state;
                            timer = setInterval(function () {
                                if (second < 0) {
                                    clearInterval(timer);
                                    _this.setState({
                                        vCode: false,
                                        second: 60,
                                    });
                                } else {
                                    _this.setState({
                                        second: second--,
                                    });
                                }
                            }, 1000);
                        }
                    );
                } else {
                    clearInterval(timer);
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                clearInterval(timer);
                Toast.info(res.msg, 1);
            }
        );
    }
    // 获取定位
    getLocation() {
        AMapLoader.load({
            key: "1fb089d0886370d069de60b28db8d101", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.Geolocation", "AMap.Geocoder"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
            .then((AMap) => {
                const geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, // 是否使用高精度定位，默认:true
                    timeout: 10000, // 超过10秒后停止定位，默认：5s
                    maximumAge: 0, // 定位结果缓存0毫秒，默认：0
                    convert: true, // 自动偏移坐标，默认：true
                    showButton: true, // 显示定位按钮，默认：true
                    buttonPosition: "LB", // 定位按钮停靠位置，默认：'LB'，左下角
                });

                // map.addControl(geolocation);
                geolocation.getCurrentPosition((status, result) => {
                    if (status === "complete") {
                        // 定位成功，返回定位信息
                        const geocoder = new AMap.Geocoder({
                            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                            city: "010",
                        });
                        geocoder.getAddress(
                            [result.position.lng, result.position.lat],
                            (type, res) => {
                                if (type === "complete" && res.info === "OK") {
                                    const {
                                        regeocode: { addressComponent },
                                    } = res;
                                    const city = addressComponent.city
                                        ? addressComponent.city.replace(
                                              "市",
                                              ""
                                          )
                                        : "";
                                    const province = addressComponent.province
                                        ? addressComponent.province.replace(
                                              "省",
                                              ""
                                          )
                                        : "";
                                    this.setState = {
                                        city,
                                        province,
                                    };
                                    const {
                                        urlOps,
                                        phoneNumber,
                                        messageCode,
                                        recordCode,
                                    } = this.state;
                                    post({
                                        url: api.inviteRegister,
                                        data: {
                                            inviteCode: urlOps.inviteCode,
                                            phoneNumber,
                                            messageCode,
                                            recordCode,
                                            operateApplicationFlag: "HIC",
                                            operateTenantFlag: "HIC",
                                            city: city ? city : "",
                                            province: province,
                                        },
                                    }).then(
                                        (res) => {
                                            if (res.result === "success") {
                                                href(
                                                    `/inviteNewUsersDownload?lastNumber=${urlOps.lastNumber}&inviteCode=${urlOps.inviteCode}`
                                                );
                                            } else {
                                                Toast.info(res.msg, 1);
                                            }
                                        },
                                        (res) => {
                                            Toast.info("注册失败", 1);
                                        }
                                    );
                                }
                            }
                        );
                        console.log("定位成功", result);
                    } else {
                        // 定位失败
                        console.log("定位失败", result);
                    }
                });
            })
            .catch((e) => {
                console.log(e);
            });
        // new BMap.LocalCity().get((result) => {
        //     if (result) {
        //         var cityName = result.name.replace("市", "");
        //         this.setState = {
        //             city: cityName,
        //         };
        //         this.getAddrAccordingPoint(result.center).then((res) => {
        //             const {
        //                 urlOps,
        //                 phoneNumber,
        //                 messageCode,
        //                 recordCode,
        //                 province,
        //                 city,
        //             } = this.state;
        //             post({
        //                 url: api.inviteRegister,
        //                 data: {
        //                     inviteCode: urlOps.inviteCode,
        //                     phoneNumber,
        //                     messageCode,
        //                     recordCode,
        //                     operateApplicationFlag: "HIC",
        //                     operateTenantFlag: "HIC",
        //                     city: cityName ? cityName : "",
        //                     province: res.province
        //                         ? res.province.replace("省", "")
        //                         : "",
        //                 },
        //             }).then(
        //                 (res) => {
        //                     if (res.result === "success") {
        //                         href(
        //                             `/inviteNewUsersDownload?lastNumber=${urlOps.lastNumber}&inviteCode=${urlOps.inviteCode}`
        //                         );
        //                     } else {
        //                         Toast.info(res.msg, 1);
        //                     }
        //                 },
        //                 (res) => {
        //                     Toast.info("注册失败", 1);
        //                 }
        //             );
        //         });
        //     }
        // });
    }
    // 逆地址解析
    // getAddrAccordingPoint(point) {
    //     const _this = this;
    //     return new Promise(function (resolve, reject) {
    //         new BMap.Geocoder().getLocation(point, function (result) {
    //             if (result) {
    //                 _this.setState = {
    //                     province: result.addressComponents.province,
    //                 };
    //                 resolve(result.addressComponents);
    //             }
    //         });
    //     });
    // }
    // 注册
    register() {
        this.getLocation();
        // this.viewPort();
    }

    render() {
        const {
            modalImgCodeType,
            selectType,
            vCode,
            second,
            phoneNumber,
            imgUrl,
            imageCode,
            messageCode,
            urlOps,
            serviceAgreenmentType,
            agreementUrl,
            recordCode,
        } = this.state;
        // console.log(urlOps)
        return (
            <div className="InviteNewUsersShareBox">
                <p className="source">
                    你的好友尾号{urlOps.lastNumber || ""}赠送你一张
                </p>
                <div className="registerBox">
                    <div>
                        <div className="inputBox">
                            <div>
                                <input
                                    type="text"
                                    placeholder="请输入手机号码"
                                    onChange={(e) => {
                                        this.setState({
                                            phoneNumber: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="请输入验证码"
                                    onChange={(e) => {
                                        this.setState({
                                            messageCode: e.target.value,
                                        });
                                    }}
                                />
                                {vCode ? (
                                    <span>{second}秒后重新获取</span>
                                ) : (
                                    <a
                                        onClick={() => {
                                            if (phoneNumber.length !== 11) {
                                                Toast.info(
                                                    "请填写正确的手机号码",
                                                    1
                                                );
                                                return;
                                            }
                                            this.getImgCode();
                                        }}
                                    >
                                        获取验证码
                                    </a>
                                )}
                            </div>
                            {recordCode ? (
                                <span>
                                    请输入接收到的验证码（编号{recordCode}）
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                        <div
                            className="reward_3_row"
                            onClick={() => {
                                if (phoneNumber.length !== 11) {
                                    Toast.info("请填写正确的手机号码", 1);
                                    return;
                                }
                                if (messageCode.length === 0) {
                                    Toast.info("请填写验证码", 1);
                                    return;
                                }
                                if (!selectType) {
                                    Toast.info(
                                        "请同意并勾选《用户协议》《隐私政策》",
                                        1
                                    );
                                    return;
                                }
                                this.register();
                            }}
                        >
                            注册领取
                        </div>
                    </div>
                    <div className="isAgreementBox">
                        <div
                            className={"radio " + (selectType ? "active" : "")}
                            onClick={() => {
                                this.setState({
                                    selectType: !selectType,
                                });
                            }}
                        >
                            <i></i>
                            <span>我已阅读并同意</span>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: true,
                                        agreementUrl: `${window.location.origin}/h5Static/#/ServiceAgreenment`,
                                    });
                                }}
                            >
                                《用户协议》
                            </a>
                            <a
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: true,
                                        agreementUrl: `${window.location.origin}/h5Static/#/PrivacyAgreement`,
                                    });
                                }}
                            >
                                《隐私政策》
                            </a>
                        </div>
                    </div>
                </div>
                <div>
                    <h2>活动规则</h2>
                    <div style={{ lineHeight: "1.5" }}>
                        1、活动时间：12月1日~12月31日（2000张无门槛充电券发完即止）；
                        <br />
                        2、活动规则：
                        <br />
                        ①邀请人在远程慧联app首页点击【邀请有奖】分享给好友，被邀请人注册后即可获得一张5元无门槛充电券，邀请人在被邀请人充值任意一笔充电费后即可获得一张5元无门槛充电券，充电券有效期30天；用户可在“我的”内查看。
                        <br />
                        ②活动结束时邀请数排名前三（若拉新数相同以谁先拉到该数量的时间排名）的用户瓜分1000元充电大礼包：第一名500元充电券，第二名300元充电券，第三名200元充电券，充电券都是20元面额，有效期一年。（每次充电只能使用一张，充电券只能本账号使用）。
                    </div>
                </div>
                {modalImgCodeType ? (
                    <div className="modalImgCodeBox">
                        <div>
                            <h3>图形验证</h3>
                            <div className="inputBox">
                                <input
                                    type="text"
                                    placeholder="图形验证码"
                                    onChange={(e) => {
                                        this.setState({
                                            imageCode: e.target.value,
                                        });
                                    }}
                                />
                                <img
                                    src={imgUrl}
                                    onClick={() => {
                                        this.getImgCode();
                                    }}
                                />
                            </div>
                            <div className="btnBox">
                                <a
                                    onClick={() => {
                                        this.setState({
                                            modalImgCodeType: false,
                                            imageCode: "",
                                        });
                                    }}
                                >
                                    取消
                                </a>
                                <a
                                    onClick={() => {
                                        if (imageCode.length === 0) {
                                            Toast.info("请填写图形验证码", 1);
                                            return;
                                        }
                                        this.getMessageCode();
                                    }}
                                >
                                    确定
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {serviceAgreenmentType ? (
                    <div className="serviceAgreenmentBox">
                        <div>
                            <div className="iframe">
                                <iframe src={agreementUrl}></iframe>
                            </div>
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: false,
                                    });
                                }}
                            >
                                确认
                            </Button>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default InviteNewUsersShare;



// WEBPACK FOOTER //
// ./src/inviteNewUsers/share/index.js